import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ModeloDocumentoDados } from '../modelo-documento.model'
import { ModeloDocumentoService } from '../modelo-documento.service'

@Component({
  selector: 'app-form-ata-prova',
  templateUrl: './form-ata-prova.component.html',
  styleUrls: ['./form-ata-prova.component.scss'],
})
export class FormAtaProvaComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  @Input() concursoId!: number
  @Input() tipoProva!: string
  @Output() formData = new EventEmitter<Record<string, string>>()

  dados?: ModeloDocumentoDados
  campos: Record<string, string> = {}
  examinadores: string[] = []
  candidatosNotas: string[] = []
  presidente = ''
  logoUnidadePreview: string | null = null

  private notasMap: Record<string, string> = {}

  private readonly titulos: Record<string, string> = {
    ATA_PROVA_ESCRITA: 'ATA DA PROVA ESCRITA',
    ATA_PLANO_TRABALHO: 'ATA DA PROVA DE ANÁLISE DO PLANO DE TRABALHO',
    ATA_PROVA_TITULOS: 'ATA DA PROVA DE TÍTULOS – FASE II',
    ATA_PROVA_DIDATICA: 'ATA DA PROVA DIDÁTICA – FASE II',
    ATA_PROVA_ARGUICAO: 'ATA DA PROVA DE ARGUIÇÃO – FASE II',
    ATA_PROVA_ESPECIFICA: 'ATA DA PROVA ESPECÍFICA',
  }

  get tituloDocumento(): string {
    let titulo = this.titulos[this.tipoProva] || ''
    if (this.campos['fase'] && (this.tipoProva === 'ATA_PROVA_ESCRITA' || this.tipoProva === 'ATA_PROVA_ESPECIFICA' || this.tipoProva === 'ATA_PLANO_TRABALHO')) {
      titulo += ' – ' + this.campos['fase'].toUpperCase()
    }
    return titulo
  }

  constructor(private service: ModeloDocumentoService) {}

  ngOnInit(): void {
    this.service.obterDados(this.concursoId, this.tipoProva)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: d => {
          this.dados = d
          this.dados.comissao.sort((a, b) => a.nome.localeCompare(b.nome))
          this.campos = { ...d.camposEditaveis }
          this.presidente = d.comissao.find(m => m.presidente)?.nome || '[Nome do Presidente]'
          this.preComputarNotas(d)
          this.emitir()
        },
        error: () => this.dados = undefined
      })
  }

  private preComputarNotas(d: ModeloDocumentoDados): void {
    const provaKey = Object.keys(d.notasPorProva)[0] || ''
    const notas = provaKey ? d.notasPorProva[provaKey] : []
    this.examinadores = [...new Set(notas.map(n => n.examinador))].sort((a, b) => a.localeCompare(b))
    this.candidatosNotas = [...new Set(notas.map(n => n.candidato))]
    this.notasMap = {}
    for (const n of notas) {
      this.notasMap[`${n.candidato}|${n.examinador}`] = n.nota
    }
  }

  get candidatosPresentes() {
    return this.dados?.candidatos.filter(c => c.categoria !== 'AUSENTE') || []
  }

  get candidatosAusentes() {
    return this.dados?.candidatos.filter(c => c.categoria === 'AUSENTE') || []
  }

  getNota(candidato: string, examinador: string): string {
    return this.notasMap[`${candidato}|${examinador}`] || ''
  }

  onLogoUpload(event: Event): void {
    const input = event.target as HTMLInputElement
    if (!input.files?.length) return
    const file = input.files[0]
    const reader = new FileReader()
    reader.onload = () => {
      const base64 = reader.result as string
      this.logoUnidadePreview = base64
      this.campos['logoUnidade'] = base64
      this.emitir()
    }
    reader.readAsDataURL(file)
  }

  emitir(): void {
    this.formData.emit(this.campos)
  }
}
